import img from "../US_img/US_ACOUSTIC_2.webp"; // adapte le chemin image
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsAcousticAW() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>ACOUSTIC AW</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Toiles acoustiques AW</h1>

          <p data-aos="fade-up">
            Les toiles acoustiques AW apportent un réel confort acoustique
            et permettent de corriger efficacement les problèmes d’échos
            et de réverbération dans les espaces professionnels et publics.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-acoustic-aw.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Acoustic AW toiles acoustiques" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US ACOUSTIC AW ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            Les toiles acoustiques AW sont conçues pour offrir de très hautes
            performances d’absorption acoustique. Elles permettent la
            réalisation de plafonds, murs, formes, baffles ou panneaux
            acoustiques.
          </p>

          <p data-aos="fade-up">
            Ces différentes configurations assurent une correction efficace
            des échos et améliorent significativement la qualité sonore et
            le confort de vie dans les espaces architecturaux.
          </p>
        </div>
      </section>

      {/* ACOUSTIQUE */}
      <section className="ut-section">
        <SectionTitle small="Performance" big="Correction acoustique" />

        <div className="ut-two-cols">
          <ul className="ut-list">
            <li>Réduction de la réverbération</li>
            <li>Amélioration de l’intelligibilité vocale</li>
            <li>Confort sonore mesurable</li>
            <li>Idéal open space & restaurants</li>
          </ul>

          <ul className="ut-list">
            <li>Compatible laine minérale</li>
            <li>Mousses absorbantes</li>
            <li>Panneaux techniques</li>
            <li>Solutions hybrides design + acoustique</li>
          </ul>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="🎧"
            title="Correction des échos"
            text="Idéal pour résoudre les problèmes de réverbération et d’échos."
          />
          <Feature
            icon="📊"
            title="Haute absorption acoustique"
            text="Coefficient d’absorption élevé (αw ≈ 65 %)."
          />
          <Feature
            icon="⚡"
            title="Pose rapide"
            text="Mise en œuvre simple et propre sans travaux lourds."
          />
          <Feature
            icon="📐"
            title="Configurations multiples"
            text="Plafonds, murs, formes, baffles ou panneaux acoustiques."
          />
          <Feature
            icon="🏢"
            title="Usage professionnel"
            text="Adapté aux espaces publics et professionnels."
          />
          <Feature
            icon="🌿"
            title="Confort et bien-être"
            text="Amélioration notable de la qualité de vie sonore."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Toiles acoustiques haute performance AW</li>
          <li>Coefficient d’absorption acoustique αw ≈ 65 %</li>
          <li>Correction efficace de la réverbération</li>
          <li>Compatible plafonds, murs et structures suspendues</li>
          <li>Intégration architecturale discrète</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Restaurants",
            "Salles de réunion",
            "Bureaux",
            "Open spaces",
            "Espaces culturels",
            "Écoles & universités",
            "Hôtels",
            "Espaces publics",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Améliorez le confort acoustique de vos espaces</h2>
        <p>Nos experts vous accompagnent dans le choix des toiles acoustiques AW.</p><br/>
        <a href="/contact" className="btn-primarya">Contactez-nous</a>
      </section>

    </div>
  );
}
